import React, { useState } from 'react';
import { Loader2, Tag, X } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { bapi } from '@/lib/billingApi';

export const couponTerm = (c) => (c.duration === 'forever' ? 'every renewal' : 'your first payment');

// Percent-off coupon for card checkout; the server re-prices at checkout, this is just the preview.
export const CouponField = ({ productId, applied, onChange }) => {
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);

  const apply = async () => {
    setBusy(true);
    try {
      const r = await bapi('/billing/coupon/preview', { method: 'POST', body: { code: code.trim(), product_id: productId } });
      onChange(r);
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };

  if (applied) {
    return (
      <div className="flex items-center justify-between gap-3 rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-2.5" data-testid="checkout-coupon-applied">
        <span className="flex items-center gap-2 text-sm text-emerald-900"><Tag className="w-4 h-4" /><b>{applied.code}</b> · {applied.percent_off}% off {couponTerm(applied)}</span>
        <button type="button" onClick={() => { onChange(null); setCode(''); }} className="text-emerald-800 hover:text-emerald-950" aria-label="Remove coupon" data-testid="checkout-coupon-remove"><X className="w-4 h-4" /></button>
      </div>
    );
  }
  if (!open) {
    return <button type="button" onClick={() => setOpen(true)} className="text-xs font-semibold text-[#00247D] underline underline-offset-2" data-testid="checkout-coupon-toggle">Have a coupon code?</button>;
  }
  return (
    <div className="flex gap-2">
      <Input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="Coupon code" autoFocus
        onKeyDown={(e) => { if (e.key === 'Enter' && code.trim()) { e.preventDefault(); apply(); } }} data-testid="checkout-coupon-input" />
      <Button type="button" variant="outline" onClick={apply} disabled={!code.trim() || busy} data-testid="checkout-coupon-apply">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Apply'}
      </Button>
    </div>
  );
};
